export const SkipLastIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M12 12L8 6.33333L4 12L12 12ZM4 5.33333L12 5.33333L12 4L4 4L4 5.33333Z" />
  </svg>
);
